import React from 'react';
import LayersGroupByList from 'components/LayersGroupByList';
import GenericAccordion from 'components/GenericAccordion';
import { color } from 'styles/Theme';

export default function Aridity({ climateList = [] }) {
	const type = 'aridez';
	const { layers } = climateList;
	const aridityList = layers.filter((item) => item.type === type);

	return (
		<GenericAccordion
			title="Aridez do ar"
			styleTitle={{
				color: `${color.interface.darkGray}`,
				fontWeight: '500'
			}}
		>
			<LayersGroupByList layers={aridityList} showTitle={false} useToggle={false} />
		</GenericAccordion>
	);
}
